import React from 'react'

import { withRouter } from 'react-router-dom'

import { Container, Statistic, Progress, Grid, Popup } from 'semantic-ui-react';

import { Section } from 'components';

import { BreadcrumbHelper } from 'utils';

import './style.css';

class DashboardScene extends React.Component {

  constructor(props) {
    super(props);

    let percentage = this.percentage(props.statistic.total_space - props.statistic.free_space, props.statistic.total_space)

    let color;

    switch (true) {

      case (percentage >= 75):
        color = "red";
        break;

      case (percentage >= 50):
        color = "orange";
        break;

      default:
        color = "green";
        break;
    }

    this.state = {
      statistic : props.statistic,
      percentage : percentage,
      progressBarColor: color
    };

    this.updateBreadcrumb();
  }

  percentage(partialValue, totalValue) {
    let percentage = ((100 * partialValue) / totalValue)
    return Math.round(percentage)
  }

  humanReadableFormat(bytes) {

    if(bytes == 0) {
      return "0 B";

    } else {

      let units = ['B', 'KB', 'MB', 'GB'/*, 'TB'*/];

      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)));

      if(i >= units.length) {
        i = units.length - 1;
      }

      return {
        value: Math.round(bytes / Math.pow(1000, i), 2),
        unit: units[i]
      };
    }
  }

  updateBreadcrumb() {

    //Update breadcrumb
    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Dashboard', '/dashboard');
    BreadcrumbHelper.flush();
  }

  renderDiskStat(bytes) {

    let format = this.humanReadableFormat(bytes);

    return (
      <Popup content={`${bytes.toLocaleString()} octets`} trigger={
        <div>

          {/* Value */}
          {format.value}

          {/* Unit */}
          <span className="unit">{format.unit}</span>
        </div>
      } size="mini" position='bottom center' />
    )
  }

  render() {

    return (
      <React.Fragment>

        {/* Stats */}
        <Container id="statistics" textAlign="center">

          <Section title="Statistiques">

            {/* Horses */}
            <Statistic>
              <Statistic.Value>{this.state.statistic.horses}</Statistic.Value>
              <Statistic.Label>Chevaux</Statistic.Label>
            </Statistic>

            {/* Clinics */}
            <Statistic>
              <Statistic.Value>{this.state.statistic.clinics}</Statistic.Value>
              <Statistic.Label>Cliniques</Statistic.Label>
            </Statistic>

            {/* Examens */}
            <Statistic>
              <Statistic.Value>{this.state.statistic.examens}</Statistic.Value>
              <Statistic.Label>Examens</Statistic.Label>
            </Statistic>

          </Section>

        </Container>

        {/* Disk usage */}
        <Container id="disk-usage">

          <Section title="Espace disque">

            <Grid>

              <Grid.Row columns={1}>
                <Grid.Column textAlign="center">

                  {/* Used space */}
                  <Statistic className="space used">
                    <Statistic.Value>{this.renderDiskStat(this.state.statistic.total_space - this.state.statistic.free_space)}</Statistic.Value>
                    <Statistic.Label>Occupé</Statistic.Label>
                  </Statistic>

                  {/* Free space */}
                  <Statistic className="space free">
                    <Statistic.Value>{this.renderDiskStat(this.state.statistic.free_space)}</Statistic.Value>
                    <Statistic.Label>Libre</Statistic.Label>
                  </Statistic>

                </Grid.Column>
              </Grid.Row>

              <Grid.Row columns={1}>
                <Grid.Column textAlign="center">

                  {/* Total space */}
                  <Statistic className="space total">
                    <Statistic.Value>{this.renderDiskStat(this.state.statistic.total_space)}</Statistic.Value>
                    <Statistic.Label>Total</Statistic.Label>
                  </Statistic>

                </Grid.Column>
              </Grid.Row>

            </Grid>

            {/* Progress */}
            <Progress size="medium" percent={this.state.percentage} color={this.state.progressBarColor} progress />

          </Section>

        </Container>

      </React.Fragment>
    );
  }
}

export default withRouter(DashboardScene);
